{
	"title": "Správa prohlášení",
	"createDeclaration": "Vytvořit prohlášení"
}
